export const CONFIGURATION_ENDPOINT = '/config.json';

export const GET_CONFIGURATION_QUERY_KEY = ['configuration'] as const;
